/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function () {
  "use strict";

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

  if (
    "serviceWorker" in navigator &&
    (window.location.protocol === "https:" || isLocalhost)
  ) {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(function (registration) {
        // updatefound is fired if service-worker.js changes.
        registration.onupdatefound = function () {
          // updatefound is also fired the very first time the SW is installed,
          // and there's no need to prompt for a reload at that point.
          // So check here to see if the page is already controlled,
          // i.e. whether there's an existing service worker.
          if (navigator.serviceWorker.controller) {
            // The updatefound event implies that registration.installing is set:
            // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
            var installingWorker = registration.installing;

            installingWorker.onstatechange = function () {
              switch (installingWorker.state) {
                case "installed":
                  // At this point, the old content will have been purged and the
                  // fresh content will have been added to the cache.
                  // It's the perfect time to display a "New content is
                  // available; please refresh." message in the page's interface.
                  break;

                case "redundant":
                  throw new Error(
                    "The installing " + "service worker became redundant."
                  );

                default:
                // Ignore
              }
            };
          }
        };
      })
      .catch(function (e) {
        console.error("Error during service worker registration:", e);
      });
  }

  // Your custom JavaScript goes here

  $(function () {
    // wait for document ready

    $(document).ready(function () {
      $(document).foundation();

      $("#header").headroom({
        offset: 100,
      });

      // Scroll Magic
      var controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: "onLeave",
        },
      });
      var slides = document.querySelectorAll("section.panel");
      for (var i = 0; i < slides.length; i++) {
        new ScrollMagic.Scene({
          triggerElement: slides[i],
        }) /*.setPin(slides[i])*/
          .setClassToggle("#p" + (i + 2), "active")
          .on("change enter leave", function () {
            $(".pindicater li").removeClass("last");
            $(".pindicater li.active").last().addClass("last");
          })
          /*.addIndicators() // add indicators (requires plugin)*/
          .addTo(controller);
      }

      var windowWidth = window.innerWidth;
      if (windowWidth > 768) {
        var pconfig = {
          "#leaderboard": {
            backgroundPosition: "38% 0%",
            ease: Linear.easeNone,
          },
          "#messages": { backgroundPosition: "25% 0%", ease: Linear.easeNone },
          "#recruit": { backgroundPosition: "0% 0%", ease: Linear.easeNone },
        };
      } else {
        var pconfig = {
          "#leaderboard": {
            backgroundPosition: "38% 0%",
            ease: Linear.easeNone,
          },
          "#messages": { backgroundPosition: "50% 0%", ease: Linear.easeNone },
          "#recruit": { backgroundPosition: "50% 0%", ease: Linear.easeNone },
        };
      }
      $.each(pconfig, function (key, val) {
        var pcontroller = new ScrollMagic.Controller({
          globalSceneOptions: { triggerHook: "onEnter", duration: "100%" },
        });
        var ptween = new TimelineMax().add([TweenMax.to(key, 1, val)]);
        new ScrollMagic.Scene({ triggerElement: key })
          .setTween(ptween)
          /*.addIndicators()*/
          .addTo(pcontroller);
      });

      // init
      var tween2 = new TimelineMax().add([
        TweenMax.fromTo(
          "#card1",
          0.2,
          { x: "+55%", opacity: 0 },
          { x: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#card2",
          0.3,
          { x: "+57%", opacity: 0 },
          { x: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#card3",
          0.4,
          { x: "+59%", opacity: 0 },
          { x: "0%", opacity: 1, ease: Linear.easeNone }
        ),
      ]);

      var controller2 = new ScrollMagic.Controller();
      var scene2 = new ScrollMagic.Scene({
        triggerElement: "#trigger2",
      })
        .setTween(tween2) // trigger a TweenMax.to tween
        /*.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)*/
        .addTo(controller2);

      var tween3 = new TimelineMax().add([
        TweenMax.fromTo(
          "#recruit1",
          0.1,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#recruit2",
          0.2,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#recruit3",
          0.3,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#recruit4",
          0.4,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#recruit5",
          0.5,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#recruit6",
          0.6,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
        TweenMax.fromTo(
          "#recruit7",
          0.7,
          { y: "+50%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeNone }
        ),
      ]);

      var controller3 = new ScrollMagic.Controller();
      var scene3 = new ScrollMagic.Scene({
        triggerElement: "#trigger3",
      })
        .setTween(tween3) // trigger a TweenMax.to tween
        /*.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)*/
        .addTo(controller3);

      var tween1 = new TimelineMax().add([
        TweenMax.fromTo(
          "#company1",
          0.2,
          { y: "25%", opacity: 0 },
          { y: "0%", opacity: 1, ease: Linear.easeInOut }
        ),
      ]);

      var controller1 = new ScrollMagic.Controller();
      var scene1 = new ScrollMagic.Scene({
        triggerElement: "#trigger1",
      })
        .setTween(tween1) // trigger a TweenMax.to tween
        /*.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)*/
        .addTo(controller1);

      $(".menu")
        .find("a")
        .each(function () {
          $(this)
            .off("click")
            .on("click", function () {
              $("#sp-btn-container").trigger("click");
              var elem = $(this);
              var target = elem.attr("href");
              $(target).animatescroll({
                scrollSpeed: 1250,
                easing: "easeInOutQuart",
              });
            });
        });

      $(function () {
        var btn = $(".back2top");
        btn.on("click", function () {
          $("body,html").animate({
            scrollTop: 0,
          });
        });
      });

      var initMap = async function () {
        var latLng = { lat: 33.586143, lng: 130.42278 };
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
          "marker"
        );

        var map = new Map(document.getElementById("company1"), {
          center: latLng,
          scrollwheel: false,
          zoom: 16,
          mapId: "STUDIO_Q_MAP_ID",
        });
        const glyphImg = document.createElement("img");
        glyphImg.src = "/images/map_marker.png";
        glyphImg.style.width = "60px";
        glyphImg.style.height = "60px";

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position: latLng,
          content: glyphImg,
        });

        var mapStyle = [{ stylers: [{ saturation: -100 }] }];
        var mapType = new google.maps.StyledMapType(mapStyle);
        map.mapTypes.set("GrayScaleMap", mapType);
        map.setMapTypeId("GrayScaleMap");
      };
      initMap();

      /*
               $('.map').click(function () {
               $('.map iframe').css("pointer-events", "auto");
               });
               $( ".map" ).mouseleave(function() {
               $('.map iframe').css("pointer-events", "none");
               });
             */

      $(document)
        .on("forminvalid.zf.abide", function (ev, frm) {
          $("#sendError").hide();
          $("#sendSuccess").hide();
        })
        .on("formvalid.zf.abide", function (ev, frm) {
          $("#sendError").hide();
          $("#sendSuccess").hide();
        });

      $(document).on("submit", function (ev) {
        ev.preventDefault();
      });

      $(document).on("formvalid.zf.abide", function (ev, frm) {
        $("#sendError").hide();
        $("#sendSuccess").hide();

        var $form = $("#contactForm"); /*.find('form')*/
        var $button = $form.find("button");

        console.log($form.serialize());

        $.ajax({
          url: "./contact.php" /*$form.attr('action')*/,
          type: "POST" /*$form.attr('method')*/,
          data: $form.serialize(),
          cache: false,
          dataType: "json",
          timeout: 10000,

          beforeSend: function (xhr, settings) {
            $button.attr("disabled", true);
          },
          complete: function (xhr, textStatus) {
            $button.attr("disabled", false);
          },
          success: function (result, textStatus, xhr) {
            $("#contactForm")[0].reset();
            $("#sendSuccess").show();
            ga(
              "send",
              "event",
              {
                eventCategory: "click",
                eventAction: "Contact",
                eventLabel: "SentContact",
                transport: "beacon",
              },
              { nonInteraction: 1 }
            );
          },
          error: function (xhr, textStatus, error) {
            $("#contactForm")[0].reset();
            $("#sendError").show();
            var message = "";
            try {
              var res = $.parseJSON(xhr.responseText);
              message = res.message;
            } catch (e) {
              message = "Uknown Error";
            }
            ga("send", "exception", {
              exDescription: "Contact Fail: " + message,
              exFatal: false,
            });
          },
        });
      });
    });
  });
})();
